export default __webpack_public_path__ + "static/media/hero_img.1dcb5748.jpg";